var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.EmployeeLoading,
          expression: "EmployeeLoading"
        }
      ],
      staticClass: "ChatChartSupervise-container"
    },
    [
      _vm.dialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "chat-content-dialog",
              attrs: {
                title: _vm.chatTitle,
                visible: _vm.dialogVisible,
                "close-on-click-modal": true,
                center: true,
                width: "600px",
                "close-on-press-escape": true
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.close
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.parmsM.currentMan) +
                              "与" +
                              _vm._s(_vm.parmsM.withMan) +
                              "的聊天摘要"
                          )
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.parmsM.date) +
                              " " +
                              _vm._s(_vm.parmsM.label)
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                355495696
              )
            },
            [
              _c("chatContent", {
                attrs: { rowData: _vm.rowData, parmsM: _vm.parmsM }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "ChatChartSupervise-l" },
        [
          _c(
            "el-select",
            {
              staticClass: "select-stafft-wrap",
              attrs: {
                size: "small",
                filterable: "",
                placeholder: "请选择",
                clearable: ""
              },
              model: {
                value: _vm.params.userId,
                callback: function($$v) {
                  _vm.$set(_vm.params, "userId", $$v)
                },
                expression: "params.userId"
              }
            },
            _vm._l(_vm.options, function(item) {
              return _c("el-option", {
                key: item.staffUserId,
                attrs: { label: item.name, value: item.staffUserId }
              })
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "employee-area" },
            _vm._l(_vm.handleEmployee, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: [
                    "employee-item",
                    {
                      "seleted-item": item.staffUserId == _vm.seletedEmployeeId
                    },
                    {
                      "disabled-item":
                        _vm.DateLoading ||
                        _vm.seletedEmployeeId == item.staffUserId
                    }
                  ],
                  on: {
                    click: function($event) {
                      return _vm.clickCurrentEm(item)
                    }
                  }
                },
                [
                  _c("li", { staticClass: "li-1" }, [
                    _c("h3", [_vm._v(_vm._s(item.name))]),
                    _c("span", [_vm._v(_vm._s(item.deptName))])
                  ]),
                  _c("li", { staticClass: "li-2" }, [
                    _vm._v("最近聊天：" + _vm._s(item.leastChatTime))
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      !_vm.errorText
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.DateLoading,
                  expression: "DateLoading"
                }
              ],
              staticClass: "ChatChartSupervise-r"
            },
            [
              _c("div", { staticClass: "title-row" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.seletedEmployeeName) + "近期与客户聊天情况摘要"
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "date-row" },
                  [
                    _c("i", {
                      class: [
                        "el-icon-arrow-left",
                        "btn",
                        { "disabled-i": _vm.handleDisabled() }
                      ],
                      on: {
                        click: function($event) {
                          return _vm.changeDate(0)
                        }
                      }
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "330px" },
                      attrs: {
                        disabled: _vm.handleDisabled(),
                        size: "small",
                        clearable: false,
                        type: "week",
                        format:
                          "yyyy 年 第 WW 周 （ " +
                          _vm.startTimeM +
                          " 至 " +
                          _vm.endTimeM +
                          " ）",
                        "picker-options": _vm.pickerOptions
                      },
                      on: { change: _vm.handleWeekChange },
                      model: {
                        value: _vm.selectedWeek,
                        callback: function($$v) {
                          _vm.selectedWeek = $$v
                        },
                        expression: "selectedWeek"
                      }
                    }),
                    _c("i", {
                      class: [
                        "el-icon-arrow-right",
                        "btn",
                        { "disabled-i": _vm.handleDisabled() }
                      ],
                      on: {
                        click: function($event) {
                          return _vm.changeDate(1)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("span")
              ]),
              _c("div", { staticClass: "content-mian" }, [
                _vm.DateOptions && _vm.DateOptions.length
                  ? _c(
                      "div",
                      { staticClass: "content-mian-box" },
                      _vm._l(_vm.DateOptions, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "date-item" },
                          [
                            _c("div", { staticClass: "date-title" }, [
                              _c("li", { staticClass: "li-1" }, [
                                _vm._v(
                                  _vm._s(item.dateM) +
                                    "(" +
                                    _vm._s(item.label) +
                                    ")"
                                )
                              ]),
                              _c("li", { staticClass: "li-2" }, [
                                _vm._v(" 共沟通"),
                                _c("span", [_vm._v(_vm._s(item.total || 0))]),
                                _vm._v("位客户 ")
                              ])
                            ]),
                            _c(
                              "div",
                              {
                                ref: "scrollContainer",
                                refInFor: true,
                                staticClass: "date-contet",
                                on: {
                                  scroll: function($event) {
                                    return _vm.handleScroll(index)
                                  }
                                }
                              },
                              [
                                _vm._l(item.dataArr, function(itemD, indexD) {
                                  return _c(
                                    "div",
                                    {
                                      key: indexD,
                                      staticClass: "dataArr-item",
                                      on: {
                                        click: function($event) {
                                          return _vm.openView(itemD, item)
                                        }
                                      }
                                    },
                                    [
                                      _c("li", { staticClass: "li-1" }, [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(itemD.earliestTime) +
                                              " 开始"
                                          )
                                        ]),
                                        _c("div", [
                                          _vm._v(" 总计"),
                                          _c("span", [
                                            _vm._v(_vm._s(itemD.totalChatNum))
                                          ]),
                                          _vm._v("条 ")
                                        ])
                                      ]),
                                      _c("li", { staticClass: "li-2" }, [
                                        _vm._v(" 与"),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              itemD.externalUserName || "--"
                                            )
                                          )
                                        ]),
                                        _vm._v("聊天 ")
                                      ])
                                    ]
                                  )
                                }),
                                _vm.handleParamsBack(index, "loading")
                                  ? _c("div", { staticClass: "loading-text" }, [
                                      _c("i", {
                                        staticClass: "el-icon-loading"
                                      }),
                                      _vm._v(" 加载中... ")
                                    ])
                                  : _vm._e(),
                                _vm.handleParamsBack(index, "noMore") &&
                                !_vm.handleParamsBack(index, "loading")
                                  ? _c("div", { staticClass: "no-more" }, [
                                      _vm._v(" 没有更多数据了 ")
                                    ])
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ]
          )
        : _c("div", { staticClass: "ChatChartSupervise-r" }, [
            _c("div", { staticClass: "errorText-main" }, [
              _c("img", {
                staticClass: "img",
                attrs: {
                  src: require("../../../assets/img/not-found.svg"),
                  alt: "404"
                }
              }),
              _c("span", [_vm._v(" " + _vm._s(_vm.errorText) + " ")])
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }